import Constants, { ItemTypeDisplayNames, ItemTypeLabels } from 'client/util/Constants';
import SaveReturnValue from 'client/components/AsidePanel/SaveReturnValue';

const { error, success } = Constants;

export default {
  methods: {
    /**
     * Add bind success message to save toast.
     *
     * @param {Object} bindResponse object with numSuccess and failedTasks
     * @param {String} targetType type that item was bound to
     * @param {Object} options any non-default values of other SaveReturnValue
     * fields
     * @return {SaveReturnValue} with updated message
     */
    parseBindSuccessMethod(bindResponse, targetType, options) {
      // No bind
      if (!bindResponse) return new SaveReturnValue(options);

      let message;
      if (bindResponse.failedTasks.length !== 0) { // Failure
        message = {
          type: error,
          message: `Failure binding ${ItemTypeLabels[this.itemType]} to ${ItemTypeLabels[targetType]}.`,
        };
      } else { // Success
        message = {
          type: success,
          message: `${ItemTypeDisplayNames[this.itemType]} saved successfully and ${ItemTypeLabels[targetType]} bind status changed successfully.`,
        };
      }

      return new SaveReturnValue({
        ...options,
        message,
      });
    },
  },
};
